import type { Asset } from '../../../../api/assetAdministrationBackendCodec.ts';
import { useState } from 'react';
import { useAppDispatch } from '../../../../../configuration/setup/hooks.ts';
import { useAssociateDeviceToAssetMutation } from '../../../../../services/assetsApi.ts';
import { sleep } from '../../../../../utils.ts';
import { assetModified } from '../assetSidebarSlice.ts';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { AssociateDeviceDialog } from '../../dialogs/AssociateDeviceDialog.tsx';

export const AssociateDevice = ({ asset }: { asset: Asset }) => {
    const [showDialog, setShowDialog] = useState(false);
    const dispatch = useAppDispatch();
    const [associateDeviceToAsset] = useAssociateDeviceToAssetMutation();

    const handleAssociate = (assetId: string, deviceIdentification: string, deviceType: string, reason: string) => {
        associateDeviceToAsset({ assetId, deviceIdentification, deviceType, reason })
            .unwrap()
            .then(() => sleep(1000))
            .then(() => dispatch(assetModified()))
            .catch(error => {
                console.error(`Could not associate asset: ${error}`);
                Notification.error('Could not associate asset');
            });
        setShowDialog(false);
    };

    return (
        <>
            <button
                type={'button'}
                className={'btn btn-info'}
                onClick={() => setShowDialog(true)}
                data-cy='associate-device-button'
            >
                Associate Device
            </button>
            <AssociateDeviceDialog
                showDialog={showDialog}
                setShowDialog={setShowDialog}
                asset={{
                    id: asset.id,
                    vin: asset.identification,
                    accountId: asset.account_id,
                    status: asset.status,
                }}
                handleConfirm={handleAssociate}
            />
        </>
    );
};
